import styled from 'styled-components'

export const AnovaLogoStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const AnovaLogoImage = styled.img`
  width: 150px;
  height: 45px;
`

export const AnovaLogoImageSmall = styled.img`
  width: 100px;
  height: 30px;
`
